import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';
import {Row, Col, Button} from 'reactstrap';
import {Maybe} from 'monet';

import Form from '@/Form';
import Text from '@/Form/Text';
import {blank} from '@/util';
import api from '@/api';

const metaFields = ['errors'];

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });
  const [flashData, setFlashData] = useState('');
  const {t: tr} = useTranslation('change_password');

  const handleSubmit = event => {
    event.preventDefault();
    setFlashData('');
    api
      .post('/change_password', R.omit(metaFields, formData))
      .then(({data}) => {
        const errors = R.propOr({}, 'errors')(data);
        if (blank(errors)) {
          setFlashData(tr('success_message'));
          setFormData({
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
          });
        }
        setFormData(R.assoc('errors', errors));
      });
  };

  const ResultMsg = () =>
    Maybe.fromFalsy(flashData)
      .map(val => <div className='alert alert-success'>{val}</div>)
      .orNull();

  return (
    <Row>
      <Col md={{size: 6, offset: 2}}>
        <h1>{tr('label')}</h1>
        <p>{tr('description')}</p>
        <ResultMsg />
        <Form stateHook={[formData, setFormData]} onSubmit={handleSubmit}>
          <Row>
            <label htmlFor='currentPassword' className='col-sm-5'>
              {tr('current')}
            </label>
            <Col md={7}>
              <Text name='currentPassword' type='password' required />
            </Col>
          </Row>
          <Row>
            <label htmlFor='newPassword' className='col-sm-5'>
              {tr('new')}
            </label>
            <Col md={7}>
              <Text name='newPassword' type='password' required />
            </Col>
          </Row>
          <Row>
            <label htmlFor='confirmNewPassword' className='col-sm-5'>
              {tr('confirm_new')}
            </label>
            <Col md={7}>
              <Text name='confirmNewPassword' type='password' required />
            </Col>
          </Row>
          <Row>
            <Col md={{size: 4, offset: 4}}>
              <Button
                type='submit'
                value='Y'
                style={{background: '#245A80', color: 'white'}}
                block
              >
                {tr('common:submit')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

export default ChangePassword;
